import List from './list/LabResearchOrderTestResultListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})